import { render } from "./CardProductLists.vue?vue&type=template&id=0aeb0d5b&scoped=true"
import script from "./CardProductLists.vue?vue&type=script&lang=js"
export * from "./CardProductLists.vue?vue&type=script&lang=js"

import "./CardProductLists.vue?vue&type=style&index=0&id=0aeb0d5b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aeb0d5b"]])

export default __exports__